'use client';

import Link from 'next/link';
import { LoadingButton } from '../LoadingButton/LoadingButton';
import { Page } from '../../lib/pageData';
import clientConfig from '../../client/config';
import styles from './GroupMembers.module.scss';
import { useTranslation } from 'react-i18next';
import { GroupMembersList } from '../GroupMembersList/GroupMembersList';
import { useFetchGroupMembers } from '../../hooks/useFetchGroupMembers';
import { isInMemoryOccasion } from '../../utils/inMemory';

type GroupMembersProps = {
  page: Page;
  className?: string;
};

export const GroupMembers = ({ page, className }: GroupMembersProps) => {
  const { t } = useTranslation();
  const isInMemoryTeam = isInMemoryOccasion(page.occasion?.type);
  const { data, loading, handleFetchMore } = useFetchGroupMembers(page);

  const members = data?.page?.fundraisers;

  if (!members) {
    return null;
  }

  return (
    <section data-testid="group-members-section" className={className}>
      <div className={styles.sectionHeader}>
        <h1 className="cp-heading-small m-0">
          {t(isInMemoryTeam? 'groupMembers.inMemTitle' : 'groupMembers.title')} ({members.totalCount})
        </h1>
        {page.membershipPolicy === 'open' && (
          <Link
            className="cp-text-link"
            href={`${clientConfig.justGivingRootUrl}/teams-creation/join/${page.legacyId}`}
          >
            {t(isInMemoryTeam? 'joinTeamInMem': 'joinTeam')}
          </Link>
        )}
      </div>
      <GroupMembersList page={{ ...page, ...data.page }} />
      {members.pageInfo.hasNextPage && (
        <LoadingButton
          onClick={handleFetchMore}
          className="cp-btn cp-btn-secondary mt-2 w-full"
          loading={loading}
        >
          {t('showMore')}
        </LoadingButton>
      )}
    </section>
  );
};
